import React from "react";

import styles from './CrossLoadingAnimation.module.css'

function Loading() {
    return <div className={styles.psoload}>
        <div className={styles.straight}></div>
        <div className={styles.curve}></div>
        <div className={styles.center}></div>
        <div className={styles.inner}></div>
    </div>
}

export default Loading;
